import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';

// Action Types
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_ERROR = "ADD_COMMENT_ERROR";

// Thunk Action Creator
export const addCommentToTask = createAsyncThunk(
    "api/Task/addComment",
    async (json, { dispatch }) => {
        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/addComment/${json.id}`,
                    {
                        id: json.id,
                        Text: json.text
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else {
                    throw new Error("Error adding comment to task");
                }

                dispatch({
                    type: ADD_COMMENT_SUCCESS,
                    payload: response.data,
                });

                getLatestTaskList();
            }
            else {

                idb.addCommentToTask(json.id, json.text);

                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: ADD_COMMENT_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        }
        catch (error) {
            dispatch({ type: ADD_COMMENT_ERROR, payload: error });
        }
    }
);
